import { IconDownload } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import IconButton from '../../components/Buttons/IconButton';
import StatsCard from '../../components/StatsCard/StatsCard';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import PromotionLinkCard from './Components/PromotionLinkCard';
import { toast } from 'sonner';

const PromotionDetails = () => {

    const { state } = useLocation();
    const [eventList, setEventList] = useState([]);
    const [revenueEventList, setRevenueEventList] = useState([])

    const getEventList = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getEventDetailsOfPromotion + state?.prId);
        loadingHide();
        if (resp.responseCode === 200) {
            setEventList(resp?.data);
        } else {
            setEventList([]);
        }
    }

    const getRevenueEventList = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getRevenueEventDetailsOfPromotion + state?.prId);
        loadingHide();
        if (resp.responseCode === 200) {
            setRevenueEventList(resp?.data);
        } else {
            setRevenueEventList([]);
        }
    }

    const getEventLogs = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getEventLogs);
        loadingHide();
        if (resp.responseCode === 200) {
            window.open(resp?.data, "_blank");
        } else {
            toast.error(resp?.message);
        }
    }

    useEffect(() => {
        getEventList();
        getRevenueEventList();
    }, []);

    return (
        <Layout>
            <div className='flex items-center justify-between gap-2 flex-wrap !mb-3'>
                <h1 className=''>Promotion Details</h1>
                <IconButton icon={<IconDownload size={20} />} text={"Download Logs"} onClickFunction={() => getEventLogs()} />
            </div>
            <PromotionLinkCard cardData={state} />

            <h2 className='!mb-2 mt-4'>Event Stats</h2>
            {eventList?.length > 0 ? <div className={`grid grid-cols-1 md:grid-cols-${eventList?.length > 6 ? 6 : eventList?.length} gap-3 mb-3`}>
                {
                    eventList?.map((item, index) => (
                        <StatsCard key={index} title={item?._id} value={item?.count} />
                    ))
                }
            </div>
                : <p className='text-center text-sm text-red-500'> No event found for this promotion.  </p>
            }

            <div className='mt-4'>
                <h2 className='!mb-2 mt-3'>Revenue Event Stats</h2>
                {revenueEventList?.length > 0 ? <div className={`grid grid-cols-1 md:grid-cols-${revenueEventList?.length > 6 ? 6 : revenueEventList?.length} gap-3 mb-3`}>
                    {
                        revenueEventList?.map((item, index) => (
                            <StatsCard key={index} title={item?._id} value={item?.count} />
                        ))
                    }
                </div>
                    : <p className='text-center text-sm text-red-500'> No Revenue event found for this promotion.  </p>
                }
            </div>

        </Layout>
    )
}

export default PromotionDetails